
<template>
  <v-overlay :value="loading" :opacity="0.01">
    <v-card class="loaderlayout" light elevation="5" shaped>
      <v-card-text>
        <v-row>
          <v-col align="center" justify="top" cols="12" class="pt-0 pb-0">
            <v-img
              class="mx-2"
              src="../assets/images/TRINITY-BOARD-LOGO_RGB_LOGO_horizontal.svg"
              max-height="80"
              max-width="300"
              contain
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="left" cols="12" class="pa-0 mt-2">
            <span style="color: var(--v-appMenu-base)">{{ message }}</span>
          </v-col>
          <v-col align="center" cols="12" class="pa-0">
            <v-progress-linear
              color="#006CAD"
              height="12"
              :indeterminate="loading"
              class="mx-auto"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- <v-card color="appMenu" dark width="300">
      <v-card-text>         
        {{message}}
        <v-progress-linear  color="white" :indeterminate="loading" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card> -->
  </v-overlay>
</template>
<style scoped>
::v-deep .loaderHeader {
  font-family: "Meiryo UI" !important;
  font-weight: 700 !important;
  font-size: 40px !important;
  color: #324154 !important;
}

::v-deep .loaderlayout {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 20px;

  width: 400px;
  height: 136px;

  background: #ffffff;
  /* shadow_card */

  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
::v-deep .tagline {
  color: #0167ab !important;
  font-family: "Meriyo UI" !important;
  font-size: 20px !important;
}
</style>
<script>
export default {
  name: "Loader",
  props: {
    loading: Boolean,
    message: String,
  },
};
</script>